import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  FLAG_GETTING_VOUCHER_TYPES,
  SHOW_ERROR_GETTING_VOUCHER_TYPES,
  CLEAR_ERROR_GETTING_VOUCHER_TYPES,
  GET_VOUCHER_TYPES,
  CLEAR_VOUCHER_TYPES,
  FLAG_GETTING_VOUCHER_TYPE,
  GET_VOUCHER_TYPE,
  CLEAR_VOUCHER_TYPE,
} from '../types';
import { VOUCHER_TYPE_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { VOUCHER_TYPE_PATH } from '../../config/paths';

const flagGettingVoucherTypes = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_VOUCHER_TYPES,
    payload: flag,
  });

const showErrorGettingVoucherTypes = (error) => (dispatch) =>
  dispatch({
    type: SHOW_ERROR_GETTING_VOUCHER_TYPES,
    payload: error,
  });

const clearErrorGettingVoucherTypes = () => (dispatch) =>
  dispatch({
    type: CLEAR_ERROR_GETTING_VOUCHER_TYPES,
  });

const getVoucherTypes = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(clearErrorGettingVoucherTypes());
    dispatch(flagGettingVoucherTypes(true));
    const query = tableFilters;
    const url = `${VOUCHER_TYPE_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const voucherTypes = await response.json();
    dispatch({
      type: GET_VOUCHER_TYPES,
      payload: voucherTypes,
    });
  } catch (error) {
    toastr.error('Error', error.message);
    dispatch(showErrorGettingVoucherTypes(error));
  } finally {
    dispatch(flagGettingVoucherTypes(false));
  }
};

const clearVoucherTypes = () => (dispatch) =>
  dispatch({
    type: CLEAR_VOUCHER_TYPES,
  });

const flagGettingVoucherType = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_VOUCHER_TYPE,
    payload: flag,
  });

const getVoucherType =
  async ({ voucherTypeId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingVoucherType(true));
      const url = `${VOUCHER_TYPE_ENDPOINT}/${voucherTypeId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const voucherType = await response.json();
      dispatch({
        type: GET_VOUCHER_TYPE,
        payload: voucherType,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingVoucherType(false));
    }
  };

const clearVoucherType = () => (dispatch) =>
  dispatch({
    type: CLEAR_VOUCHER_TYPE,
  });

const postVoucherType =
  async ({ name, description, voucherCode, displayInPaymentsPage }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingVoucherType(true));
      const payload = {
        name,
        description,
        voucherCode,
        displayInPaymentsPage
      };
      const url = VOUCHER_TYPE_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const voucherType = await response.json();
      dispatch(push(`${VOUCHER_TYPE_PATH}/${voucherType.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingVoucherType(false));
    }
  };

const putVoucherType =
  async (voucherTypeId, { name, description, voucherCode,displayInPaymentsPage }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingVoucherType(true));
      const payload = {
        id: voucherTypeId,
        name,
        description,
        voucherCode,
        displayInPaymentsPage
      };
      const url = `${VOUCHER_TYPE_ENDPOINT}/${voucherTypeId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const voucherType = await response.json();
      dispatch(push(`${VOUCHER_TYPE_PATH}/${voucherType.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingVoucherType(false));
    }
  };

const deleteVoucherType =
  async ({ voucherTypeId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingVoucherType(true));
      const url = `${VOUCHER_TYPE_ENDPOINT}/${voucherTypeId}`;
      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      await response;
      dispatch(push(VOUCHER_TYPE_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingVoucherType(false));
    }
  };

export {
  flagGettingVoucherTypes,
  showErrorGettingVoucherTypes,
  clearErrorGettingVoucherTypes,
  getVoucherTypes,
  clearVoucherTypes,
  getVoucherType,
  postVoucherType,
  putVoucherType,
  clearVoucherType,
  deleteVoucherType,
};
